export const getIsTeamData = () =>
  window.localStorage.getItem('overview') === 'team'
